import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL?.trim();
const publishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY?.trim();

export const configurationError = !url || !publishableKey
  ? "VITE_SUPABASE_URL and VITE_SUPABASE_PUBLISHABLE_KEY must be configured."
  : undefined;

export const supabase = createClient(
  url || "https://invalid.supabase.co",
  publishableKey || "invalid",
  {
    db: { schema: "trading_informant" },
    auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
  },
);
